/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs */

const en_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating extended AD mixdown...`)
};

const fr_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du mixdown d'AD étendue...`)
};

const de_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterter AD-Mixdown wird erstellt...`)
};

const it_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione di un mixdown AD esteso...`)
};

const ru_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание расширенного AD-микса...`)
};

const es_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando una mezcla AD extendida...`)
};

const zh_cn2_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建扩展的广告混音...`)
};

const ja_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張 AD ミックスダウンを作成しています...`)
};

const hi_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विस्तारित AD मिक्सडाउन तैयार किया जा रहा है...`)
};

const pt_pt2_audio_description_export_status_creating_mixdown_extended = /** @type {(inputs: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando uma mixagem AD estendida...`)
};

/**
* | output |
* | --- |
* | "Creating extended AD mixdown..." |
*
* @param {Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_creating_mixdown_extended = /** @type {((inputs?: Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Creating_Mixdown_ExtendedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "de") return de_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "it") return it_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "ru") return ru_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "es") return es_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "ja") return ja_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "hi") return hi_audio_description_export_status_creating_mixdown_extended(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_creating_mixdown_extended(inputs)
	return en_audio_description_export_status_creating_mixdown_extended(inputs)
});